import request from "@/CommonDP/utils/request";

export default {
  // 添加图纸集目录树
  prjDrawingSetAdd(params) {
    return request.post("/drawing-set/add", params);
  },
  // 图纸集目录树列表
  prjDrawingSetList(prjId) {
    return request.get(`/drawing-set/getTree?prjId=` + prjId);
  },
  // 编辑图纸集目录树
  prjDrawingSetRename(params) {
    return request.post("/drawing-set/rename", params);
  },
  // 删除图纸集目录树
  prjDrawingSetDelete(listId) {
    return request.get(`/drawing-set/delete?listId=` + listId);
  },
  // 复制 复制到图纸集目录树
  prjDrawingSetCopy(listId, parentId) {
    return request.get(`/drawing-set/copy?listId=` + listId + '&parentId=' + parentId);
  },
  // 详情图纸集目录树
  prjDrawingSetGetByListId(listId) {
    return request.get(`/drawing-set/getByListId?listId=` + listId);
  },
  // 项目详情
  getProjectDetails(projectId) {
    return request.get(`/project/getProjectDetails?projectId=` + projectId);
  },
  // 四种人
  getUserList(enterpriseId, prjId, roleName, specId) {
    return request.get(`/project/spec/role/user/list?enterpriseId=` + enterpriseId + '&prjId=' + prjId + '&roleName=' + roleName + '&specId=' + specId);
  },
  // 新增图纸文件
  prjDrawingSetPlanEditAdd(params) {
    return request.post("/drawingSetPlanEdit/add", params);
  },
  // 查询图纸文件列表
  prjDrawingSetPlanEditList(params) {
    return request.post("/drawingSetPlanEdit/list", params);
  },
  // 批量删除图纸文件
  prjDrawingSetPlanEditDatchDelete(params) {
    return request.post("/drawingSetPlanEdit/batchDelete", params);
  },
  // 上移，下移数据
  prjDrawingSetPlanEditMove(params) {
    return request.post("/drawingSetPlanEdit/move", params);
  },
  // 自动编号
  drawingCodeUpdate(params) {
    return request.post("/drawingSetPlanEdit/drawingCode/update", params);
  },
  // 查询当前图纸集下的文件名称列表
  prjFileNameList(listId) {
    return request.get(`/drawingSetPlanEdit/fileName/list?listId=` + listId);
  },
  // 合并图纸至文件
  prjDrawingToFileMerge(params) {
    return request.post("/drawingSetPlanEdit/drawingToFile/merge", params);
  },
  // 解除图纸合并
  prjDrawingToFileunMerge(params) {
    return request.post("/drawingSetPlanEdit/drawingToFile/unMerge", params);
  },
  // 同一文件下的其他图纸名称
  prjDrawingByFileList(listId, fileName) {
    return request.get(`/drawingSetPlanEdit/drawingByFile/list?listId=` + listId + '&fileName=' + fileName);
  },
  // 批量修改图纸文件
  prjDrawingSetPlanEditBatchUpdate(params) {
    return request.post("/drawingSetPlanEdit/batchUpdate", params);
  },
  // 导入数据
  prjDrawingSetPlanEditImport(params) {
    return request.post(`/drawingSetPlanEdit/import`, params);
  },
  // 导入后重复数据的处理方法
  prjDrawingSetPlanEditBatchImport(params) {
    return request.post(`/drawingSetPlanEdit/batchImport`, params);
  },
  // 发布
  prjDrawingSetPlanEditPublish(listId) {
    return request.post(`/drawingSetPlanEdit/publish?listId=${listId}`);
  },
  // 企业人员基础信息列表
  getPersonnelSimpleList(enterpriseId) {
    return request.get(`/enterprise/personnel/getPersonnelSimpleList?enterpriseId=` + enterpriseId);
  },
  // 查询所有显示的图框字段
  getFrameColumnList(enterpriseId) {
    return request.get(`/frameCustomization/getFrameColumnList?enterpriseId=` + enterpriseId);
  },
  // 导出excel
  setPlanEditExportExcel(params) {
    return request({
      responseType: "blob",
      url: "/drawingSetPlanEdit/exportExcel",
      method: "post",
      data: params
    });
  }
};
